import { UnscheduledEvent } from '../../types';
import { zuluToEpochSeconds } from './dateTimeUtils';

/**
 * True when the Next Scheduled Flight departs before the event's Next Advise or
 * ERTS/RTS time — i.e. the aircraft is scheduled to fly before maintenance is
 * expected to finish.
 *
 * Single source of truth for that condition: it drives the green outline on the
 * modal's Next Scheduled Flight (STS) date/time fields and the matching green
 * text on the homepage's Next Flight / STD columns, so the two never diverge.
 */
export function isNextScheduledFlightEarly(event: UnscheduledEvent): boolean {
  const flight = zuluToEpochSeconds(event.nextScheduledFlightTimeZulu);
  if (flight === undefined) return false;
  const nextAdvise = zuluToEpochSeconds(event.nextAdviseTimeZulu);
  const erts = zuluToEpochSeconds(event.returnToServiceTimeZulu);
  return (nextAdvise !== undefined && flight < nextAdvise) || (erts !== undefined && flight < erts);
}
